var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 6.00001H19.3333V3.33334C19.3333 1.85334 18.1466 0.666672 16.6666 0.666672H11.3333C9.85329 0.666672 8.66663 1.85334 8.66663 3.33334V6.00001H3.33329C1.85329 6.00001 0.679959 7.18667 0.679959 8.66667L0.666626 23.3333C0.666626 24.8133 1.85329 26 3.33329 26H24.6666C26.1466 26 27.3333 24.8133 27.3333 23.3333V8.66667C27.3333 7.18667 26.1466 6.00001 24.6666 6.00001ZM16.6666 6.00001H11.3333V3.33334H16.6666V6.00001Z",
    fill: "#858585"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColab);
export default __webpack_public_path__ + "static/media/colab.7dbcee6ac9f4013ff30eb1d2f73d6a4c.svg";
export { ForwardRef as ReactComponent };